const getters = {
  token: state => state.user.token,
  from:state => state.user.from,
  orgId: state => state.user.orgId,
  examId: state => state.user.examId,
}
export default getters
